import styled from 'styled-components';

export const AboutContainer = styled.div`
  background: #f3f1ea;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  ${'' /* height: 600px; */}
  position: relative;
  z-index: 1;
  height: calc(100vh - 160px);
  ${'' /* height: fit-content; */}
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 20px;
    height: fit-content;
    min-height: calc(100vh - 80px);
  }
  ${
    '' /* 
  // возможно стоит убать этот before, тк он для того, чтобы сделать фон видео темнее
  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transperent 100%);

    z-index: 2;
  } */
  }
`;

export const AboutContent = styled.div`
  z-index: 3;
  ${'' /* max-width: 1200px; */}
  ${'' /* position: absolute; */}
    ${'' /* padding: 8px 24px; */}
    display: flex;
  flex-direction: column;
  align-items: center;

  ${
    '' /* @media screen and (max-width: 1024px) {
        max-width: 800px;
    } */
  }
  ${'' /* max-width: 800px; */}
`;

export const AboutH1 = styled.h3`
  color: #000;
  margin-top: 15px;
  font-size: 32px;
  text-align: center;

  ${'' /* @media screen and (max-width: 768px) {
    font-size: 32px;
  } */}

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const AboutP = styled.ul`
  margin-top: 24px;
  color: #000;
  font-size: 24px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    padding: 0 30px;
  }

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;
export const AboutElem = styled.li`
  margin-top: 7px;
  :marker {
    content: '— ';
  }
`;

export const AboutSubtext = styled.h3`
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  margin: 20px 0;

  ${'' /* @media screen and (max-width: 760px) {
    font-size: 40px
  } */}

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;
